import { AnyPeriod } from "@ct-react/core";
import { AgeCategory } from "@shared/models/article";

export type GuestsInput = { [AgeCategory.ADULT]: number, [AgeCategory.CHILD]: number, [AgeCategory.EXEMPT]: number };

type SearchInput = {
  objectTypes?: number[];
  surface?: number;
  roomsRange?: [ number, number ];
  name?: string;
  parking?: boolean;
  pool?: boolean;
}

type AnyRentalSearchInput = {
  guests?: GuestsInput;
  wifi?: boolean;
  pet?: boolean;
  cityCenter?: boolean;
  skiArea?: boolean;
}

type AnyWithPriceSearchInput = {
  priceRange?: [ number, number ];
}

export type RentalSearchInput = SearchInput & AnyRentalSearchInput & { period?: { period: AnyPeriod } };
export type SeasonalSearchInput = SearchInput & AnyRentalSearchInput & AnyWithPriceSearchInput;
export type AnnualSearchInput = SearchInput & AnyWithPriceSearchInput;
export type SaleSearchInput = SearchInput & AnyWithPriceSearchInput;

export type AnySearchInput = RentalSearchInput | SeasonalSearchInput | AnnualSearchInput | SaleSearchInput;

type PaginationDirection = "before" | "after";

export type SearchPagination = {
  direction: PaginationDirection;
  cursor?: string;
}

const anyRentalKeys: (keyof AnyRentalSearchInput)[] = [ "guests", "wifi", "pet", "cityCenter", "skiArea" ];

export const searchAnyRental = (value: AnySearchInput): value is AnyRentalSearchInput => anyRentalKeys.some(k => k in value);
export const searchWithGuests = (value: AnySearchInput): value is AnyRentalSearchInput => !!value && "guests" in value;
export const searchWithPrice = (value: AnySearchInput): value is AnyWithPriceSearchInput => !!value && "priceRange" in value;
export const searchWithPeriod = (value: AnySearchInput): value is RentalSearchInput => !!value && "period" in value;

export const countGuests = (value?: GuestsInput): number => !value ? 0 : value.ADULT + value.CHILD + value.EXEMPT;
